import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import useMainstreamCareers from "../../utils/useMainstreamCareers";
import Loader from "../loader/Loader";
import Tabs from "../tabs/Tabs";
import WelcomeCard from "../WelcomeCard";

const RecommendCareers = () => {
  const { currentJob, targetJob } = useSelector((state) => state?.user);
  const queryClient = useQueryClient();

  const {
    data: recommendData,
    isPending,
    error,
  } = useMainstreamCareers(currentJob);

  useEffect(() => {
    if (currentJob) {
      queryClient.invalidateQueries(["mainstreamCareers"]); // Refetch when currentJob changes
    }
  }, [currentJob, queryClient]);

  const memoizedRecommendationData = useMemo(() => {
    return {
      similar: recommendData?.top_3_similar_occupations || [],
      advance: recommendData?.top_3_advance_occupations || [],
      lateral: recommendData?.top_3_lateral_occupations || [],
    };
  }, [recommendData]);

  // Simple message since career components were removed
  const tabData = [];

  return (
    <div className="flex flex-col gap-6">
      <WelcomeCard
        title="Existing Careers"
        current={currentJob}
        target={targetJob}
        // description="Embark on transformative career paths designed to equip you with cutting-edge skills, empowering you to excel in your field, adapt to AI advancements, and thrive in an ever-evolving, tech-driven future."
      />

      {/* Show Loader while fetching data */}
      {isPending && (
        <div className="h-screen">
          <Loader />
        </div>
      )}

      {/* Error Handling */}
      {error && (
        <div className="text-center text-red-500 font-semibold">
          Error fetching recommendations. Please try again later.
        </div>
      )}

      {/* Handle empty data case */}
      {!isPending && !error && tabData.length === 0 && (
        <div className="text-center text-gray-600 font-medium">
          No career recommendations available at the moment.
        </div>
      )}

      {/* Show Tabs if data is available */}
      {!isPending && !error && tabData.length > 0 && <Tabs tabs={tabData} />}
    </div>
  );
};

export default RecommendCareers;
